import React, { useState } from 'react';
import { motion, AnimatePresence, useTransform, useScroll } from 'motion/react';
import { parseRedesignHeadingRTF } from '../../util/xhtmlParser.tsx';
const tabContentVariants = {
    hidden: {
        opacity: 0,
        x: 20
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.4,
            ease: 'easeOut'
        }
    },
    exit: {
        opacity: 0,
        x: -20,
        transition: {
            duration: 0.3,
            ease: 'easeIn'
        }
    }
};
const TabsDesktop = ({ items, textColorClass }) => {
    const [currentTab, currentTabSet] = useState(0);
    const toggleItem = (index) => {
        currentTabSet(currentTab === index ? currentTab : index);
    };
    const { scrollYProgress } = useScroll();
    return (React.createElement(motion.div, { className: "hidden lg:flex flex-row justify-between", style: { y: useTransform(scrollYProgress, [0, 1], [0, 75]) } },
        React.createElement("ul", { className: "flex flex-col w-2/5" }, items?.map((item, index) => (React.createElement("li", { key: index, className: `flex flex-col justify-between text-black py-[14px] pr-[20px] pl-[29px] cursor-pointer group transition-all duration-300 ${index === currentTab
                ? 'border-l-solid border-l-secondary-singaporeOrange border-l-[11px]'
                : 'border-l-solid border-l-[1px] border-l-mediumGray pl-[39px]'}`, onClick: () => toggleItem(index) },
            React.createElement("p", { className: `text-2xl mb-1 ${textColorClass} font-medium group-hover:underline` }, item.title),
            React.createElement("p", { className: `text-base ${textColorClass} ${index === currentTab ? 'font-medium' : 'font-normal'}` }, item.description))))),
        React.createElement("div", { className: `flex flex-col bg-secondary-100 rounded-[16px] ml-8 w-3/5 ${textColorClass}` },
            React.createElement(AnimatePresence, { mode: "wait" },
                React.createElement(motion.div, { key: currentTab, variants: tabContentVariants, initial: "hidden", animate: "visible", exit: "exit", className: "p-6" }, parseRedesignHeadingRTF(items?.[currentTab]?.tabContent || '', {
                    textColorClass
                }))))));
};
export default TabsDesktop;
